/**
 * @flow
 * @author: VaraKumar
 */

import React, { Component } from 'react'

import TextTestimonial from '../TextTestimonial'
import TestimonialVideoCard from '../VideoTestimonial'

import {
  ImageIncludedTextComponentContainer,
  TestimonialImage,
  ImageContainer,
  TextTestimonialContainer
} from './styledComponents'

class ImageIncludedTextComponent extends Component {
  render() {
    const {
      imageUrl,
      textTestimonialHeading,
      textTestimonialHeadingWithoutH2,
      textTestimonialContent,
      ImageCustomWidth,
      TextTestimonialCustomWidth,
      alignRowReverse,
      isDark,
      isVideo,
      videoId,
      altText,
      videoAltText,
      isVideoThumbnail,
      thumbnailVideoUrl,
      includeBottomMargin,
      id
    } = this.props

    return (
      <ImageIncludedTextComponentContainer
        id={id}
        alignRowReverse={alignRowReverse}
        includeBottomMargin={includeBottomMargin}
      >
        {isVideo ? (
          <ImageContainer ImageCustomWidth={ImageCustomWidth}>
            <TestimonialVideoCard
              thumbnailUrl={imageUrl}
              videoAltText={videoAltText}
              videoId={videoId}
              excludeBottomMargin
              isVideoThumbnail={isVideoThumbnail}
              thumbnailVideoUrl={thumbnailVideoUrl}
            />
          </ImageContainer>
        ) : (
          <ImageContainer ImageCustomWidth={ImageCustomWidth}>
            <TestimonialImage
              className="lazyload"
              draggable={false}
              dataSrc={imageUrl}
              alt={altText}
            />
          </ImageContainer>
        )}

        <TextTestimonialContainer
          TextTestimonialCustomWidth={TextTestimonialCustomWidth}
        >
          <TextTestimonial
            textTestimonialHeading={textTestimonialHeading}
            textTestimonialHeadingWithoutH2={textTestimonialHeadingWithoutH2}
            textTestimonialContent={textTestimonialContent}
            isDark={isDark}
            excludeBottomMargin
          />
        </TextTestimonialContainer>
      </ImageIncludedTextComponentContainer>
    )
  }
}

export default ImageIncludedTextComponent



// WEBPACK FOOTER //
// ./src/components/Home/TestimonialSection/TestimonialComponents/MediaAndTextComponent/index.js